module.exports = __webpack_public_path__ + "img/bg.b3738362.jpg";